import { connect } from "react-redux";

import { AppState } from "../../core/reducers/rootReducer";
import * as tncActionTypes from "../../core/actionTypes/tncActionTypes";
import * as profileDetailsActionTypes from "../../core/actionTypes/profileDetailsActionTypes";
import { Dispatch } from "react";
import { getTransactionIdFromURL, isUserLoggedIn } from "../../constants/utils";
import { submitTncConsent } from "../../core/actionCreators/tncActionCreator";
import { getTnc } from "../../core/actionCreators/tncActionCreator";
import TnC from "./tnc";
import { getProfileDetails } from "../../core/actionCreators/profileDetailsActionCreators";

const mapStateToProps = (state: AppState) => {
  let txnId = getTransactionIdFromURL();
  return {
    tncDetails: state.tnc,
    profileDetails: state.profileDetails,
    isLoading: state.isLoading[tncActionTypes.SUBMIT_TNC_CONSENT] || state.isLoading[profileDetailsActionTypes.GET_PROFILE_DETAILS] || state.isLoading[tncActionTypes.GET_TNC],
    isAuthenticated: isUserLoggedIn(txnId),
    errorTncSubmitConsent: state.error[tncActionTypes.SUBMIT_TNC_CONSENT],
    errorProfileDetails: state.error[profileDetailsActionTypes.GET_PROFILE_DETAILS],
    errorTncDetails: state.error[tncActionTypes.GET_TNC],
    partnerData: state.auth,
    transactionDetails: state.transactionDetails,
  };
};


const mapDispatchToProps = (dispatch: Dispatch<profileDetailsActionTypes.ProfileActions | tncActionTypes.TncActions>) => ({
  getProfileDetails: () => {
    dispatch(getProfileDetails());
  },
  getTnc: () => {
    dispatch(getTnc());
  },
  submitTncConsent: (request: object) => {
    dispatch(submitTncConsent(request));
  }
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TnC);
